import styled from 'styled-components';
import { Typography } from '@web-chat-core/ui-kit';

export const Wrapper = styled.div`
    position: absolute;
    left: 5px;
    bottom: 5px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 4px 6px;
    background: ${props => props.theme.label.background};
    width: fit-content;
    gap: 3px;
`;

export const Time = styled(Typography)``;
